import { FeatureFlags as CatalogFeatureFlags } from '@tableau/catalog-ui-temp';
import { defaultMemoize } from 'reselect';
import { FeatureFlag, FeatureFlagService } from '../../services/FeatureFlagService';

const cachedFlags: CatalogFeatureFlags = {
  metricsDataCatalogEnabled: FeatureFlagService.instance.getValue(FeatureFlag.metricsDataCatalogEnabled),
  writableFieldDescriptionsEnabled: FeatureFlagService.instance.getValue(FeatureFlag.writableFieldDescriptionsEnabled),
  fieldDescriptionInheritanceLineageEnabled: FeatureFlagService.instance.getValue(FeatureFlag.fieldDescriptionInheritanceLineageEnabled),
  publishedConnectionsLineageEnabled: FeatureFlagService.instance.getValue(FeatureFlag.publishedConnectionsLineageEnabled),
  databasesInProjectsEnabled: FeatureFlagService.instance.getValue(FeatureFlag.databasesInProjectsEnabled),
  lensLineageEnabled: FeatureFlagService.instance.getValue(FeatureFlag.lensLineageEnabled),
  relevantAssetsEnabled: FeatureFlagService.instance.getValue(FeatureFlag.relevantAssetsEnabled),
  mixedContentConnectToDialogEnabled: FeatureFlagService.instance.getValue(FeatureFlag.mixedContentConnectToDialogEnabled),
  customSensitivityLabelsEnabled: FeatureFlagService.instance.getValue(FeatureFlag.customSensitivityLabelsEnabled),
  searchAndFilterOnLineagePageEnabled: FeatureFlagService.instance.getValue(FeatureFlag.searchAndFilterOnLineagePageEnabled),
};

export const catalogFeatureFlagsAdapter = defaultMemoize((): CatalogFeatureFlags => {
  return { ...cachedFlags };
});
